import { Tooltip } from '@material-ui/core';
import CSS from 'csstype';
import React, { JSX, useState } from 'react';

import { PauseIcon, RefreshCycleIcon } from '~/src/dash/components/icons/misc-icons';
import { TrendsPillIcon } from '~/src/dash/components/icons/pill-icons';
import { Col, Cols, Text, TKey, usePublicaTranslation } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { IconV2 } from '~/src/dash/components/icons/IconV2';

type ToggleIconSlug = 'pause' | 'refresh' | 'trends' | 'download';

interface ISortIconProps {
  color: string;
  iconSlug?: ToggleIconSlug;
}

const ToggleIcon = ({ color, iconSlug }: ISortIconProps) => {
  switch (iconSlug) {
    case 'pause':
      return <PauseIcon color={color} style={{ height: '11px' }} />;
    case 'refresh':
      return <RefreshCycleIcon color={color} />;
    case 'trends':
      return <TrendsPillIcon color={color} />;
    case 'download':
      return <IconV2 name='download' color={color} />;
    default:
      return <></>;
  }
};

interface IIconTextToggleProps {
  activeBackgroundColor?: string;
  activeColor?: string;
  buttonStyle?: CSS.Properties;
  defaultBackgroundColor?: string;
  defaultColor?: string;
  handleOnClick: () => void;
  hoverBackgroundColor?: string;
  hoverColor?: string;
  iconSlug?: ToggleIconSlug;
  isActive: boolean;
  label?: string;
  textStyle?: CSS.Properties;
  tKey?: TKey;
  tooltip?: string | JSX.Element;
}

export const IconTextToggle = ({
  activeBackgroundColor = publicaColors.honeydew,
  activeColor = publicaColors.jungleGreen,
  buttonStyle = {},
  defaultBackgroundColor = publicaColors.veryLightGray,
  defaultColor = publicaColors.black,
  handleOnClick,
  hoverBackgroundColor = publicaColors.lightGray,
  hoverColor = publicaColors.black,
  iconSlug,
  isActive,
  label,
  textStyle = {},
  tKey,
  tooltip = '',
}: IIconTextToggleProps) => {
  const { t } = usePublicaTranslation();
  const [isHovered, setIsHovered] = useState<boolean>(false);

  const color = isActive ? activeColor : isHovered ? hoverColor : defaultColor;

  const backgroundColor = isActive
    ? activeBackgroundColor
    : isHovered
    ? hoverBackgroundColor
    : defaultBackgroundColor;

  return (
    <Tooltip title={tooltip}>
      <button
        style={{
          display: 'inline-block',
          borderWidth: 0,
          margin: 0,
          padding: '6px 16px',
          borderRadius: '6px',
          backgroundColor,
          fontFamily: 'inherit',
          whiteSpace: 'nowrap',
          cursor: 'pointer',
          ...buttonStyle,
        }}
        onClick={() => handleOnClick()}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Cols
          gap='4px'
          style={{
            alignItems: 'center',
          }}
        >
          {iconSlug && (
            <Col displayFlex style={{ minWidth: '14px' }}>
              <ToggleIcon color={color} iconSlug={iconSlug} />
            </Col>
          )}
          {label && (
            <Col>
              <Text
                disableSelect
                small
                bold
                style={{
                  color,
                  lineHeight: 'inherit',
                  fontStyle: 'inherit',
                  ...textStyle,
                }}
                tKey={tKey}
              >
                {tKey ? t(tKey) : label}
              </Text>
            </Col>
          )}
        </Cols>
      </button>
    </Tooltip>
  );
};
